import React, { Component } from 'react'
import clsx from 'clsx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  CssBaseline, CircularProgress, Container, Button, Grid, Typography,
  Card, CardContent, Chip, Divider, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper
} from '@mui/material'
import { withStyles } from '@mui/styles'
import { Styles } from '../../styles/material-styles'
import { Overlay } from '../../styles/global'
import CustomizedSnackbars from '../../components/material-snackbars'
import HeaderMenu from '../../components/header-menu'
import Footer from '../../components/footer'
import { injectIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import * as componentActions from '../../redux/actions/organizations'

import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart'
import UpgradeIcon from '@mui/icons-material/Upgrade'
import InventoryIcon from '@mui/icons-material/Inventory'

import { getContractProducts } from '../../services/subscription.service'

class MyProducts extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      openNotification: false,
      notificationVariant: 'error',
      notificationMessage: '',
      products: [],
      hirerId: 0,
    }

    this.closeNotification = this.closeNotification.bind(this)
  }

  async componentDidMount() {
    const hirerId = this.props.userSession && this.props.userSession.user
      ? this.props.userSession.user.hirerid
      : 0

    if (hirerId) {
      this.setState({ hirerId, loading: true })
      await this.loadProducts(hirerId)
      this.setState({ loading: false })
    }
  }

  async loadProducts(hirerId) {
    try {
      const result = await getContractProducts(hirerId || this.state.hirerId)
      if (result && result.data && result.data.data) {
        const data = result.data.data
        const products = Array.isArray(data) ? data : []
        this.setState({ products })
      }
    } catch (err) {
      console.error('Error loading products:', err)
    }
  }

  formatCurrency(value, currency) {
    if (value == null) return '-'
    const cur = currency || 'BRL'
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: cur }).format(value)
  }

  closeNotification() {
    this.setState({ openNotification: false })
  }

  render() {
    const { classes, headerMenu } = this.props
    const intl = this.props.intl
    const { products, loading } = this.state
    const lang = this.props.match.params.lang

    return (
      <div className={classes.root} style={{ paddingLeft: 0, marginLeft: 0 }}>
        <HeaderMenu />
        <main className={clsx(classes.content, { [classes.contentShift]: headerMenu.open })}>
          <div className={classes.drawerHeader} />
          <Container component='main' maxWidth='lg' style={{ paddingLeft: 24 }}>
            <CssBaseline />

            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <div>
                <Typography variant="h5" style={{ fontWeight: 700, marginBottom: 4 }}>
                  {intl.formatMessage({ id: 'my.products.title' })}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {intl.formatMessage({ id: 'my.products.subtitle' })}
                </Typography>
              </div>
              <Button
                variant="contained"
                startIcon={<AddShoppingCartIcon />}
                component={Link}
                to={`/${lang}/add-product`}
                style={{
                  backgroundColor: '#8BC34A', color: '#fff',
                  textTransform: 'none', fontWeight: 600
                }}
              >
                {intl.formatMessage({ id: 'my.products.add' })}
              </Button>
            </div>

            {loading ? (
              <div style={{ textAlign: 'center', padding: 40 }}>
                <CircularProgress />
              </div>
            ) : products.length === 0 ? (
              <Card elevation={2}>
                <CardContent style={{ textAlign: 'center', padding: 40 }}>
                  <InventoryIcon style={{ fontSize: 64, color: '#bdbdbd', marginBottom: 16 }} />
                  <Typography variant="h6" color="textSecondary">
                    {intl.formatMessage({ id: 'my.products.empty' })}
                  </Typography>
                  <Typography variant="body2" color="textSecondary" style={{ marginBottom: 16 }}>
                    {intl.formatMessage({ id: 'my.products.empty.description' })}
                  </Typography>
                  <Button
                    variant="contained"
                    startIcon={<AddShoppingCartIcon />}
                    component={Link}
                    to={`/${lang}/add-product`}
                    style={{ backgroundColor: '#8BC34A', color: '#fff', textTransform: 'none' }}
                  >
                    {intl.formatMessage({ id: 'my.products.add.first' })}
                  </Button>
                </CardContent>
              </Card>
            ) : (
              <TableContainer component={Paper} elevation={2}>
                <Table>
                  <TableHead>
                    <TableRow style={{ backgroundColor: '#f5f5f5' }}>
                      <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.product' })}</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.plan' })}</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.periodicity' })}</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.quantity' })}</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.value' })}</TableCell>
                      <TableCell style={{ fontWeight: 600 }}>{intl.formatMessage({ id: 'my.products.col.agents' })}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {products.map((p, idx) => {
                      const name = p.applicationname || p.applicationName || '-'
                      const plan = p.planname || p.planName || '-'
                      const periodicity = p.periodicityname || p.periodicityName || '-'
                      const qty = p.quantity || 1
                      const value = p.planvaluepermonth || p.planValuePerMonth
                      const agents = p.agentlimitquantity || p.agentLimitQuantity

                      return (
                        <TableRow key={idx}>
                          <TableCell>
                            <Typography variant="body1" style={{ fontWeight: 500 }}>{name}</Typography>
                          </TableCell>
                          <TableCell>
                            <Chip label={plan} size="small" style={{ backgroundColor: '#e3f2fd', color: '#1565c0' }} />
                          </TableCell>
                          <TableCell>{periodicity}</TableCell>
                          <TableCell>{qty}</TableCell>
                          <TableCell style={{ fontWeight: 500 }}>{this.formatCurrency(value)}</TableCell>
                          <TableCell>{agents != null ? agents : '-'}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}

          </Container>
          <Footer />
        </main>

        <CustomizedSnackbars
          variant={this.state.notificationVariant}
          message={this.state.notificationMessage}
          isOpen={this.state.openNotification}
          toClose={this.closeNotification}
        />

        {this.state.loading && (
          <Overlay>
            <CircularProgress color="secondary" />
          </Overlay>
        )}
      </div>
    )
  }
}

MyProducts.propTypes = {}

const mapStateToProps = state => ({
  userSession: state.userSession,
  headerMenu: state.headerMenu,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(componentActions, dispatch)

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(MyProducts)))
